export const pages = {
	'boltSynopsis': { id: 'boltSynopsis', page: 'home', getter: () => import(/* webpackChunkName: 'boltSynopsis' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "boltGallery" */ 'components/bolt/gallery/gallery'), component: 'gallery' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
